module.exports = __webpack_public_path__ + "img/1.41d8ebbe.gif";